import { ROUTES } from '../../consts/Routes'
import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAppSelector } from '../../reducers/hooks'

export interface AuthType {
  authed: boolean
}

export const isAuthenticated = (): boolean => {
  const token = useAppSelector((state) => state.user.token)
  const lsToken = localStorage.getItem('token')
  const sessionId = useAppSelector((state) => state.user.sessionId)
  const lsSessionId = localStorage.getItem('sessionId')
  if ((token !== null || lsToken !== null) && (sessionId !== null || lsSessionId !== null)) return true
  return false
}

export const useAuth = (): AuthType => {
  return { authed: isAuthenticated() }
}

const ProtectedRoutes: React.FC = (): JSX.Element => {
  const { authed } = useAuth()
  return authed ? <Outlet /> : <Navigate to={ROUTES.HOME} />
}

export default ProtectedRoutes
